const TabManagerModel = {};

TabManagerModel.EVENTS = {
  NOTIFICATIONS: {
    CLOSE: 'notifications.close',
  },
  ORDER: {
    FINISH: 'order.finish',
  },
};

export default TabManagerModel;
